module.exports = __webpack_public_path__ + "static/media/partner-icon-catalyst-white.63e660ba.svg";